<template>
<!--  <div style="width: 100%; padding-top: 10px;height: 5.3rem;overflow: hidden" v-if="isShow">-->
  <div style="width: 100%; padding-top: 10px;height: 80vh;overflow: hidden" v-if="isShow">
    <swiper
      ref="mySwiper"
      :options="swiperOptions"
      :key="swiperKey"
      class="swiper-container"
      @slide-change="slideChange">
<!--     @swiper="handleSwiper"  @transition-start="transitionStart"-->
      <swiper-slide
        class="swiper-slide"
        v-for="item in contentList"
        :key="item.id">
        <div class="swiper-slide-container">
          <div>
            <div v-show="isVideo(item)" style="width: 100%;height: 1.7rem;">
              <video :id="'flyVideo' + item.id" :ref="'flyVideo' + item.id" muted style="width: 100%; height: 100%;" :poster="getImgUrl(item.imgList)" preload="meta" controls="controls">
                <source :src="item.videoUrl"
                        style=" margin: 0;"
                        type="video/mp4">
              </video>
            </div>
            <a href="javascript:void(0);" @click="hanldeAppDetail(item)" >
              <img v-if="isImg(item.imgList) && !isVideo(item)" :src="getImgUrl(item.imgList)">
              <img v-else-if="!isVideo(item)" :src="item.coverImage || item.thumUrl">
              <h2 style="color: #2c3e50;margin-top: 10px;padding: 10px;padding-bottom: 0;text-align: left;font-size: 26px">
                {{ item.title }}
              </h2>
              <p style="color: #2c3e50;font-size: 16px;padding: 10px;text-align: left">
                {{ item.introduction || '' }}
              </p>
            </a>
          </div>

          <div style="display: flex;justify-content: space-between;align-items: center;padding: 0 10px;position: relative">
            <div
              v-if="!isHBApp"
              style="color: #6FAF00;font-size: 14px;display: flex;align-items: center"
              @click="hanldeShare(item)">
              <img style="width: 20px;height: 20px;margin-right: 8px" src="../../assets/share.png">
              <span>分享</span>
            </div>
            <div
                v-else>      </div>
            <img style="height: 40px;width: 40px;position: absolute;left: 50%;margin-left: -20px" src="../../assets/lookUp.gif">
<!--            <span style="color: #6FAF00;font-size: 14px;padding-right: 5px" @click="hanldeAppDetail(item)">查看详情</span>-->
            <a
              style="color: #6FAF00;font-size: 14px;padding-right: 5px"
              href="javascript:void(0);"
              @click="hanldeAppDetail(item)">查看详情</a>
          </div>
        </div>
      </swiper-slide>

    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import dsbridge from 'dsbridge'

export default {
  name: "FlyCard",
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    isHBApp: {
      type: Boolean,
      default: false
    },
    isShow: {
      type: Boolean,
      default: false
    },
    contentList: {
      type: Array,
      default: () => []
    },
    pgnum: {
      type: Number,
      default: 1
    },
    isWeixin: {
      type: Boolean,
      default: false
    },
    isQQ: {
      type: Boolean,
      default: false
    },
    isWeibo: {
      type: Boolean,
      default: false
    },
    isPc: {
      type: Boolean,
      default: false
    },
    isApp: {
      type: Boolean,
      default: false
    },
    isIOS: {
      type: Boolean,
      default: false
    },
    isiPhone: {
      type: Boolean,
      default: false
    },
    isiPad: {
      type: Boolean,
      default: false
    },
    isAndroid: {
      type: Boolean,
      default: false
    },
    activeContentID: {
      type: String,
      default: ''
    },
    activeContentData: {
      type: Object,
      default: () => {}
    },
    // activeVideoUrl: {
    //   type: String,
    //   default: ''
    // },
  },
  data() {
    return {
      contentListLackUpdata: false,
      swiperKey: Math.random().toString(36).substr(2), /*随机的key*/
      swiperOptions: {
        direction : 'vertical', // 纵向滑动
        watchSlidesProgress : true,  //查看slide的progress
        resistanceRatio : 0, //禁止边缘移动
        on: {
          init: function(){
            let slides = this.slides
            for(let i=0; i< slides.length; i++){
              let slide = slides.eq(i)
              slide.css('zIndex', 1000-i);  //设置slide的z-index层级
            }
          },

          resize: function(swiper){
            swiper.update()
          },

          setTranslate: function(){
            let slides = this.slides
            // offsetAfter = this.height*0.95 //每个slide的位移值
            let offsetAfter = this.height * 0.95  //每个slide的位移值 this.height * 0.972

            for(let i=0; i< slides.length; i++){
              let slide = slides.eq(i)
              let progress = slides[i].progress



              if(progress <= 0){  //右边slide位移
                slide.transform('translate3d(0, '+ (progress)*offsetAfter + 'px, 0) scale('+(1 - Math.abs(progress)/20)+')');
                slide.css('opacity',(progress + 3));    //最右边slide透明
              }

              if(progress > 0){
                // slide.transform('rotate('+ (-progress)*10+'deg)');   //左边slide旋转
                slide.css('opacity',1 - progress);    //左边slide透明
              }
            }
          },
          setTransition: function(swiper, transition) {
            for (let i = 0; i < this.slides.length; i++) {
              let slide = this.slides.eq(i)
              slide.transition(transition);
            }
          },

          slideChangeTransitionEnd: swiper => {
            if (this.contentListLackUpdata) {
              let slides = swiper.slides
              for(let i=0; i< slides.length; i++){
                let slide = slides.eq(i)
                slide.css('zIndex', 1000-i);  //设置slide的z-index层级
              }

              this.contentListLackUpdata = false
            }
          }
        },

        praiseTimer: null, // 节流点赞定时器

        activeVideoDom: null,
      }
    }
  },
  watch: {
    // activeContentData(val) {
    //   console.log(val.videoUrl);
    // }

    // activeVideoUrl(val) {
    //   if (val === this.activeContentData.videoUrl) {
    //     this.$nextTick(() => {
    //       if (this.activeVideoDom) {
    //         this.activeVideoDom.pause()
    //         this.activeVideoDom = null
    //       }
    //       setTimeout( () => {
    //         const flyVideoRefName = 'flyVideo' + this.activeContentID
    //         this.activeVideoDom = document.getElementById(flyVideoRefName)
    //         this.activeVideoDom.load()
    //         this.activeVideoDom.play()
    //       }, 1000)
    //     })
    //
    //   }
    // }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    }
  },
  methods: {
    hanldeShare(data) {
      this.$emit('handlerShare', data)
    },
    hanldeAppDetail(data) {
      // console.log(data);
      // window.open(data.url)
      // this.isHBApp
      if (this.isHBApp) {
        dsbridge.call('detaiToSocialPlatformModelDic', JSON.stringify(data))
      }else {
        const { url: dataUrl, isLinks, linksUrl } = data
        // const dataUrl = data.url // `https://testnewsoss.hndnews.com/test/html/mobile/513525.html`
        if (isLinks === 1){
          window.open(linksUrl)
        }else {
          this.$router.push({
            path: '/detail',
            query: {url: encodeURI(dataUrl)}
          })
        }

      }
    },
    slideChange({ activeIndex }) {
      if ((this.contentList.length - activeIndex) <= 7){
        this.$emit('contentListLack')
      }
      // this.$emit('contentListLack')
      this.$emit('slideChange', this.contentList[activeIndex])

    },
    // handleSwiper(e) {
    //   console.log(e);
    // },
    // transitionStart(e) {
    //   console.log(e);
    // },
    isImg(list) {
      if (!list) return false
      const url = list[0]?.url
      if (url) {
        return /\.(gif|jpg|jpeg|png|GIF|JPG|PNG|blob)$/.test(url)
      }
      return false
    },
    isVideo(data) {
      const { videoUrl, isLinks } = data

      if ((videoUrl?.length > 0) && (isLinks !== 1)) {
        // console.log(this.$refs);
        return /\.(mp4|flv|avi|rm|rmvb)$/.test(videoUrl)
      }
      return false
    },
    getImgUrl(list) {
      if (!list || list.length < 1) return ''
      return list[0].url
    },
    handlerPlayVideo({ id }) {
      this.$nextTick(() => {
        if (this.activeVideoDom) {
          this.activeVideoDom.pause()
          this.activeVideoDom = null
        }
        setTimeout( () => {
          const flyVideoRefName = 'flyVideo' + id
          this.activeVideoDom = document.getElementById(flyVideoRefName)
          this.activeVideoDom.load()
          this.activeVideoDom.play()
        }, 1000)
      })
    },
    handlerPauseVideo({ id }) {
      this.activeVideoDom = document.getElementById('flyVideo' + id)
      if (this.activeVideoDom) {
        this.activeVideoDom.pause()
        this.activeVideoDom = null
        this.$emit('pauseVideo')
      }
    },
    refreshSwiperKey() {
      this.contentListLackUpdata = true
    }
  }
}
</script>

<style scoped>
.swiper-container {
  width: 100%;
  height: 100%;
  /*height: 100%;*/
}
.swiper-slide {
  box-sizing: border-box;
  text-align: center;
  padding: 0 0.4rem;
}
.swiper-slide .swiper-slide-container{
  box-sizing: border-box;
  width:100%;
  border-radius:7px;
  height: 90%;
  /*height: 5rem;*/
  /*min-height: 480px;*/
  box-shadow: 0 0.666667vw 3.066667vw 1.466667vw rgb(0 0 0 / 13%);
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 30px;
  overflow: hidden;
}

.swiper-slide-container h2{
  overflow:hidden;
  text-overflow:ellipsis;
  display:-webkit-box;
  -webkit-box-orient:vertical;
  -webkit-line-clamp:2;
}

.swiper-slide div img{
  width:100%;
  max-height: 3rem;
  display:block;
  border-radius:7px;
}

</style>